<template>
    <div class="sld_login">
        <div class="mask" v-if="isRegister==1">
            <div class="login_Popup">
                <div class="Popup_header">
                    <div>{{L['注册账号']}}</div>
                    <div class="close" @click="cancel"></div>
                </div>
                <div class="Popup_bodyer">
                    <div style="background:transparent">
                        <img src="../../../assets/folder.png" style="width:53px;height:53px">
                    </div>
                    <div>{{L['注册成功']}}</div>
                    <!-- <div @click="goToPage('/businessInfo')" style="cursor:pointer">{{L['提交经营信息']}}</div> -->
                    <div @click="goToPage('/businessInfo')" style="cursor:pointer">下一步</div>
                </div>
            </div>
        </div>
        <div class="sld_login_header">
            <div class="content">
                <router-link tag="a" class="l_logo" :to="`/index`">
                    <img class='img' :src="configInfo.main_site_logo" :onerror='defaultImg' alt />
                </router-link>
                <div class="r_register_wrap">
                    <span>{{L['已有账号？']}}</span>
                    <a href="javascript:void(0)" class="go_register_btn" @click="goToPage('/login')">
                        {{L['去登录']}}
                    </a>
                </div>
            </div>
        </div>
        <div class="sld_login_content">
            <img class="bg" :src="configInfo.main_user_register_bg" :onerror='defaultBgImg' alt />
            <div class="login">
                <div class="login_box">
                    <div class="top">
                        <div class="item1">{{L['注册账号']}}</div>
                    </div>
                  
                    <div class="center">
                        <div class="item account">
                            <span style="color: #BBB;font-size: 21px;padding-top: 7px"
                                class="icon iconfont icon-shouji2"></span>
                            <input type="text" v-model="name" :placeholder="L['请输入会员名']" class="input">
                            <div data-type="userName" class="cancel" @click="clearInputVal('name')">
                                <span style="color: #bbb;" class=" iconfont icon-cuowu"></span>
                            </div>
                        </div>
                        <div class="item password">
                            <span style="color: #BBB;font-size: 18px;padding-top: 8px"
                                class="icon iconfont icon-yanzhengma2"></span>
                            <input type="password" v-model="password" :placeholder="L['请输入密码']" class="input">
                            <div data-type="userName" class="cancel" @click="clearInputVal('password')">
                                <span style="color: #bbb;" class=" iconfont icon-cuowu"></span>
                            </div>
                        </div>
                        <div class="item password">
                            <span style="color: #BBB;font-size: 18px;padding-top: 8px"
                                class="icon iconfont icon-yanzhengma2"></span>
                            <input type="password" v-model="password_again" :placeholder="L['请再次输入密码']" class="input">
                            <div data-type="userName" class="cancel" @click="clearInputVal('password_again')">
                                <span style="color: #bbb;" class=" iconfont icon-cuowu"></span>
                            </div>
                        </div>
                        <div class="error">
                            <span v-if="errorMsg" style="color: #e1251b;font-size: 14px"
                                class="iconfont icon-jubao"></span>
                            {{errorMsg}}
                        </div>
                        <a href="javascript:void(0)" @click="login" class="login_btn">{{L['立即注册']}}</a>
                        <div class="agree_wrap">
                            <input type="checkbox" :class="{checkbox:true, default:true, checked:agreeFlag}" />
                            <span class="agree_selected iconfont icon-finish" @click="agree" />
                            <span class="text">
                                我同意<router-link tag="a" class="agreement" :to="`/agreement`">《用户注册协议及隐私政策》</router-link>
                            </span>
                        </div>
                    </div>
                    <div class="bottom flex_row_end_center">
                        <a href="javascript:void(0)" @click="goToPage('/login')">
                            {{L['已有账号，去登录']}}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { useRouter } from 'vue-router';
    import { ref, getCurrentInstance, onMounted, watch } from 'vue';
    import { useStore } from 'vuex';

    export default {
        name: "Register",
        setup() {
            const isRegister = ref(false);
            const store = useStore();
            const agreeFlag = ref(false);//同意注册协议标识，默认不同意
            const name = ref('');//用户名
            const errorMsg = ref();//错误提示
            const password = ref('');//密码
            const password_again = ref('');//再次输入密码
            const imgCode = ref('');//图形验证码
            const router = useRouter();
            const { proxy } = getCurrentInstance();
            const L = proxy.$getCurLanguage();
            const countDownM = ref(0);//短信验证码倒计时
            const timeOutId = ref('');//定时器的返回值
            const showCodeImg = ref('');//图形验证码图片
            const imgCodeKey = ref('');//图形验证码的key
            const configInfo = ref(store.state.configInfo)
            const defaultImg = ref('this.src="' + require('../../../assets/common_top_logo.png') + '"')
            const defaultBgImg = ref('this.src="' + require('../../../assets/login_bg.png') + '"')
            const cancel = () => {
                isRegister.value = false;

            }
            const login = () => {
                let param = {};
                param.memberName = name.value;
                param.loginPwd = password.value;
                param.verifyPwd = password_again.value;
                param.source = 1
                //会员名验证
                if (!param.memberName) {
                    errorMsg.value = L['请输入会员名'];
                    return false;
                }else {
                    let name = proxy.$checkMemberName(param.memberName)
                    if(name!==true){
                    errorMsg.value = name;
                    return false;
                    }
                }

                //密码验证
                if (!param.loginPwd) {
                    errorMsg.value = L['请输入密码'];
                    return false;
                } 
                // 密码验证
                if (param.loginPwd.length<6) {
                    errorMsg.value = '密码不能小于6位';
                    return false;
                } 
                //再次输入密码验证
                 if (!param.verifyPwd) {
                    errorMsg.value = L['请再次输入密码'];
                    return false;
                } else if(param.password!=param.password_again){
                    errorMsg.value = L['两次输入密码不一致'];
                    return false;
                }

                if (!agreeFlag.value) {
                    errorMsg.value = '请同意用户注册协议及隐私政策';
                    return false;
                }

                //如果未登录vuex中有购物车数据，需同步到该用户
                let cartInfo = [];
                let cartListData = store.state.cartListData;
                if (JSON.stringify(cartListData) != '{}') {
                    cartListData.storeCartGroupList.map(cartListItem => {
                        cartListItem.promotionCartGroupList.map(promotItem => {
                            promotItem.cartList.map(cartItem => {
                                cartInfo.push({
                                    productId: cartItem.productId,
                                    buyNum: cartItem.buyNum
                                })
                            })
                        })
                    })
                }
                param.cartInfo = JSON.stringify(cartInfo);

                proxy.$post('v3/frontLogin/oauth/register', param).then(res => {
                    if (res.state == 200) {
                        isRegister.value = true;
                        //将用户信息存缓存，并跳转到首页
                        localStorage.setItem('access_token', res.data.access_token);
                        localStorage.setItem('refresh_token', res.data.refresh_token);
                        localStorage.setItem('time', new Date().getTime().toString());//存储refresh_token更新时间
                        //获取用户信息，并同步信息到vuex
                        proxy.$get('/v3/member/front/member/getInfo').then(res => {
                            if (res.state == 200) {
                                //清空购物车store
                                proxy.$sldStatEvent({ behaviorType: 'reg' })
                                store.commit('updateCartListData', {});
                                store.commit('updateMemberInfo', res.data);
                                // router.back();
                            }
                        })
                    } else {
                        //提示错误
                        getImgCode();
                        errorMsg.value = res.msg
                    }
                })
            }
            //清空输入框内容
            const clearInputVal = (type) => {
                if (type == 'name') {
                    name.value = '';
                } else if (type == 'password') {
                    password.value = '';
                }else if (type == 'password_again') {
                    password_again.value = '';
                }
            }

            //获取短信验证码
            const getSmsCode = () => {
                if (countDownM.value) {
                    return false;
                }
                let checkMobile = proxy.$checkPhone(name.value);
                let checkImgCode = proxy.$checkImgCode(imgCode.value);
                if (checkMobile !== true) {
                    errorMsg.value = checkMobile;
                } else if (checkImgCode !== true) {
                    errorMsg.value = checkImgCode;
                } else {
                    let param = {};
                    param.mobile = name.value;
                    // param.verifyType = 2;
                    param.verifyCode = imgCode.value;
                    param.verifyKey = imgCodeKey.value;
                    proxy.$get('v3/msg/front/commons/getCaptcha', param).then(res => {
                        if (res.state == 200) {
                            countDownM.value = 60;
                            countDown();
                        } else {
                            //提示错误
                            getImgCode();
                            errorMsg.value = res.msg
                        }

                    })
                }
            }
            //倒计时
            const countDown = () => {
                countDownM.value--;
                if (countDownM.value == 0) {
                    clearTimeout(timeOutId.value);
                } else {
                    timeOutId.value = setTimeout(countDown, 1000);
                }
            }
            //获取图形验证码
            const getImgCode = () => {
                proxy.$get('v3/captcha/common/getCaptcha', {}).then(res => {
                    if (res.state == 200) {
                        showCodeImg.value = 'data:image/png;base64,' + res.data.captcha;
                        imgCodeKey.value = res.data.key;
                    }
                })
            }
            //是否同意用户注册协议
            const agree = () => {
                agreeFlag.value = !agreeFlag.value;
            }
            getImgCode();//获取图形验证码
            //通过replace方式跳转页面
            const goToPage = (type) => {
                router.replace({
                    path: type,
                });
            }


            //限制会员名、密码长度
            watch([name, password_again, password], () => {
                password.value = password.value.substring(0, 20)
                password_again.value = password_again.value.substring(0, 20)
                name.value = name.value.substring(0, 30)
                if (password.value || password_again.value || name.value) {
                    errorMsg.value = ''
                }
            })


            onMounted(() => {
                document.body.classList.remove('el-popup-parent--hidden');
            })
            return {
                L,
                login,
                name,
                password,
                password_again,
                clearInputVal,
                errorMsg,
                getSmsCode,
                countDownM,
                imgCode,
                showCodeImg,
                imgCodeKey,
                getImgCode,
                agreeFlag,
                agree,
                goToPage,
                configInfo,
                defaultImg,
                defaultBgImg,
                isRegister,
                cancel,
            };
        },
    };
</script>
<style lang="scss" scoped>
    @import '../../../style/register.scss';

    .el-popup-parent--hidden {
        overflow: visible;
    }
</style>